import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_purchase_orders_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { filters?: { owner?: string, project?: string, warehouse?: string, status?: string, lookup?: string, owner_reference?: string, vendor_reference?: string, order_id?: number, created_from?: string, created_to?: string, fulfilled_from?: string, fulfilled_to?: string, order_class_type?: string }, paging?: { top?: number, skip?: number }, exclude?: { shipments?: boolean, order_lines?: boolean, addresses?: boolean, shipped_contents?: boolean, tasks?: boolean }, as_export?: boolean }): Promise<{ orders?: $frontendTypes.FootprintApiManager.public_order[] }> 
  {
    let $url = `${environment.backendUrl}api/purchase_orders/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

